export default build =>
    build.mutation({
        query(payload) {         
            return {
                url: '/product/updateProductCategory',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['allProductCategories'],       
    })
